export default __webpack_public_path__ + "static/media/Facebook.a2ceda67.png";